
import React, { useState } from 'react';
import Bg from '../../../images/shapes/shape_title_under_line.svg'
import shape1 from '../../../images/shapes/shape_line_2.svg'
import shape2 from '../../../images/shapes/shape_line_3.svg'
import shape3 from '../../../images/shapes/shape_line_4.svg'
import shape4 from '../../../images/shapes/shape_space_3.svg'

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import TechnologySection from '../TechnologySection/TechnologySection';
import Testimonial from '../Testimonial/Testimonial';

const processSteps = [
    {
        id: '1',
        title: '01. Discovery Phase',
        label: 'Discovery Phase',
        description: 'We begin by understanding your business goals, current systems, user needs and operational challenges. This phase helps us define the right scope, priorities and technology direction before any build work starts.',
    },
    {
        id: '2',
        title: '02. Design and Development',
        label: 'Design and Development',
        description: 'We turn the agreed requirements into clear user flows, practical interfaces and reliable technical architecture. Development is handled in focused stages so your team can review progress and give feedback early.',
    },
    {
        id: '3',
        title: '03. Maintenance',
        label: 'Maintenance',
        description: 'After delivery, we support the solution with updates, bug fixes, performance improvements and technical guidance. Maintenance keeps your website, application or cloud system stable as your business grows.',
    },
    {
        id: '4',
        title: '04. Deployment',
        label: 'Deployment',
        description: 'We prepare the production environment, configure required services, validate integrations and manage the release process. The goal is a smooth go-live with minimal disruption to your users and operations.',
    },
    {
        id: '5',
        title: '05. Testing and QA',
        label: 'Testing and QA',
        description: 'We test key workflows, responsive layouts, forms, integrations, performance and security considerations before launch. Quality assurance helps reduce defects and gives your team confidence in the final solution.',
    },
];

const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="process_kritlogy_review_section bg-light section_decoration">
            <div className="container">
                <div className="row align-items-center justify-content-lg-between">
                    <div className="col-lg-6">
                        <div className="heading_block">
                            <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg})` }}>
                                Working Process
                            </div>
                            <h2 className="heading_text mb-0">
                                Our <mark>Approach</mark>
                            </h2>
                        </div>
                        <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                            {processSteps.map((step) => (
                                <AccordionItem className="accordion-item" key={step.id}>
                                    <AccordionHeader targetId={step.id}>
                                        {step.title}
                                    </AccordionHeader>
                                    <AccordionBody accordionId={step.id} className='acc_body'>
                                        <p className="m-0">
                                            {step.description}
                                        </p>
                                    </AccordionBody>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                    <div className="col-lg-5">
                        <ul className="content_layer_group unordered_list_block text-center">
                            {processSteps.map((step) => (
                                <li key={step.id}>
                                    <button
                                        type="button"
                                        className={`accordion-button ${open === step.id ? '' : 'collapsed'}`}
                                        onClick={() => toggle(step.id)}
                                        aria-expanded={open === step.id}
                                    >
                                        <span>{step.label}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <TechnologySection/>
                <Testimonial/>
            </div>

            <div className="decoration_item shape_image_1">
                <img src={shape1} alt="Krit Shape" />
            </div>
            <div className="decoration_item shape_image_2">
                <img src={shape2} alt="Krit Shape" />
            </div>
            <div className="decoration_item shape_image_3">
                <img src={shape3} alt="Krit Shape" />
            </div>
            <div className="decoration_item shape_image_4">
                <img src={shape4} alt="Krit Shape" />
            </div>
        </section>
    )
};
export default FaqSection;
